import { connect } from 'react-redux';
import { addTour, editTour, editTourImage, requestTour, messageDismiss, requestTourManagers,requestBidsets,requestProposals } from '../modules/tour';

import TourDetail from '../components/TourDetail';

const mapDispatchToProps = {
  requestTour,
  editTour,
  editTourImage,
  addTour,
  messageDismiss,
  requestTourManagers,
  requestBidsets,
  requestProposals,
};

const mapStateToProps = (state, ownProps) => (
  {
    id: state.tours.selectedTour.id,
    active: ownProps.params.key,
    detailTab: ownProps.params.detail,
    detailSelect: ownProps.params.detailSelect,
    isFetching: state.tours.selectedTour.isFetching,
    needFetch: state.tours.selectedTour.needFetch,
    tour: state.tours.selectedTour.tour,
    messages: state.tours.selectedTour.messages,
    isTourManager: state.auth.perms.includes('tour_management') || state.tours.tourManagerSim,
    tourManagers: state.tours.tourManagers
  });

export default connect(mapStateToProps, mapDispatchToProps)(TourDetail);



// WEBPACK FOOTER //
// src/routes/tours/containers/TourDetailContainer.js